/**
 * @author Marmini Alluri
 * @description 
 */

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Select } from 'antd';

import localStorage from '../../../../../utils/localStorage';
const { Option } = Select;

const SelectAPI = (props) => {
    const [optionList, setOptionList] = useState([]);
    const { api, value, handleFieldChange, graphProps } = props;

    const _getOptionList = async () => {
        const siteId = localStorage.get('currentSite');
        const accessToken = localStorage.get('accessToken');
        let objectHeader = {};
        if (api && api.url && api.method) {
            objectHeader = {
                method: api.method,
                url: `${api.url}?SiteId=${siteId}`,
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            };
        }
        try {
            const response = await axios(objectHeader);
            if (Array.isArray(response.data)) {
                setOptionList(response.data);
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            setOptionList([]);
        }
    };

    useEffect(() => {
        _getOptionList();
    }, []);
    return (
        <>
            <Select
                value={value}
                onChange={handleFieldChange}
            >
                {optionList &&
                    Array.isArray(optionList) &&
                    optionList.map((data, index) => {
                        let responseType = graphProps.responseType;
                        if (responseType === "arrayOfObjects") {
                            return <Option key={index} value={data[graphProps.responseTypeArrayOfObjects["value"]]}>
                                {data[graphProps.responseTypeArrayOfObjects["key"]]}
                            </Option>;
                        } else {
                            return <Option key={index} value={data}>
                                {data}
                            </Option>;
                        }
                    })}
            </Select>
        </>
    );
};

export default SelectAPI;
